/** Builds a router-compatible path array for task navigation. */
export function getTaskUrl(projectId: string, taskId?: string): string[] {
  if (taskId) {
    return ['/projects', projectId, 'tasks', taskId];
  }
  return ['/projects', projectId, 'tasks'];
}
